import React from 'react'
import { mdiAccessPoint, mdiAlertCircleOutline, mdiCheckCircleOutline, mdiTruckFastOutline } from '@mdi/js'
import Box from '@components/Common/Box'
import Loader from '@components/Feedback/Loader'
import { useAppSelector } from '@redux/hooks'
import conditionaRender from '@utils/conditionalRender'

const ChartViagemAplicativo: React.FC = () => {

    const { viagensAplicativo, chartViagemAplicativo } = useAppSelector(s => s.viagem)
    const { requestGetViagensAplicativo } = useAppSelector(s => s.requestViagem)

    const CR = conditionaRender(requestGetViagensAplicativo, viagensAplicativo, true)

    return(

        <>
            {CR.LOADING && <Loader />}
            {CR.DATA && (
                <Box.Group columns = {4}>
                    <Box.Item
                        statusTitle = "Total"
                        theme = "status info"
                        padding = "32px 24px"
                    >
                        <Box.Section>
                            <Box.Icon
                                icon = {mdiAccessPoint}
                                title = {chartViagemAplicativo?.totalViagens}
                                size = "32px"
                            />
                        </Box.Section>
                    </Box.Item>

                    <Box.Item
                        statusTitle = "Em aberto"
                        theme = "status warning"
                        padding = "32px 24px"
                    >
                        <Box.Section>
                            <Box.Icon
                                icon = {mdiTruckFastOutline}
                                title = {chartViagemAplicativo?.totalViagensAtiva}
                                size = "32px"
                            />
                        </Box.Section>
                    </Box.Item>

                    <Box.Item
                        statusTitle = "Sucesso"
                        theme = "status success"
                        padding = "32px 24px"
                    >
                        <Box.Section>
                            <Box.Icon
                                icon = {mdiCheckCircleOutline}
                                title = {chartViagemAplicativo?.totalViagensSucesso}
                                size = "32px"
                            />
                        </Box.Section>
                    </Box.Item>

                    <Box.Item
                        statusTitle = "Insucesso"
                        theme = "status error"
                        padding = "32px 24px"
                    >
                        <Box.Section>
                            <Box.Icon
                                icon = {mdiAlertCircleOutline}
                                title = {chartViagemAplicativo?.totalViagensOcorrencia}
                                size = "32px"
                            />
                        </Box.Section>
                    </Box.Item>
                </Box.Group>
            )}
        </>

    )

}

export default ChartViagemAplicativo